import { MiscTestStudentInput, StudentInput, StudentMindprintInput } from "app/bookings/validations"
import { z } from "zod"

export const MapTestingSubscriptionCheckoutInput = z.object({
  numberOfStudents: z.number().refine((n) => n > 0, "Number of students must be greater than 0"),
  billingType: z.union([z.literal("month"), z.literal("year")]),
  sourceId: z.string(),
  coupon: z.string().optional().nullable(),
})
export type MapTestingSubscriptionCheckoutType = z.infer<typeof MapTestingSubscriptionCheckoutInput>

export const MapAcceleratorUpdateInput = z.object({
  students: z.record(z.boolean()),
  interval: z.union([z.literal("month"), z.literal("year")]),
  sourceId: z.string().optional(),
  coupon: z.string().optional().nullable(),
})
export type MapAcceleratorUpdateType = z.infer<typeof MapAcceleratorUpdateInput>

export const MapReadingFluencyInput = z.object({
  students: z.array(StudentInput),
})
export type MapReadingFluencyType = z.infer<typeof MapReadingFluencyInput>

export const MindprintInput = z.object({
  students: z.array(StudentMindprintInput),
})
export type MindprintInputType = z.infer<typeof MindprintInput>

export const MiscTestInput = z.object({
  students: z.array(MiscTestStudentInput),
})
export type MiscTestInputType = z.infer<typeof MiscTestInput>
